export var ESettingLanguage;
(function (ESettingLanguage) {
    ESettingLanguage["eng"] = "English";
    ESettingLanguage["du"] = "Dutch";
    ESettingLanguage["fr"] = "French";
})(ESettingLanguage || (ESettingLanguage = {}));
